/** @type {import('../schema').ProcessDefinition} */
const whatsappHabi = {
  id: "whatsapp-habi",
  name: "Atención por WhatsApp + Bot Habi",
  category: "ia",
  outcome:
    "Responder a residentes 24/7 por WhatsApp con un bot, escalando a humano cuando hace falta, todo desde una bandeja.",
  trigger:
    "Un mensaje entrante del residente (webhook de Meta) llega al backend de Habi.",
  actors: ["Residente", "Bot Habi", "Administrador", "Meta/WhatsApp"],
  status: "COMPLETO",
  description:
    "Recepción del mensaje, clasificación y recuperación de contexto, respuesta del bot (en modo aprendizaje se registra para revisión y no se envía; en producción se envía), revisión por Super Admin, escalación a humano y devolución del hilo al bot.",
  lanes: [
    { id: "res", actor: "Residente" },
    { id: "bot", actor: "Bot Habi" },
    { id: "admin", actor: "Administrador" },
    { id: "meta", actor: "Meta/WhatsApp" },
  ],
  steps: [
    { id: "s1", laneId: "res", type: "start", label: "Envía un mensaje por WhatsApp", description: "El residente escribe al edificio; entra por el webhook de Meta.", evidence: "propia_agent/main.py" },
    { id: "s2", laneId: "meta", type: "task", label: "Recibe el mensaje en el hilo", description: "El mensaje entra al hilo (whatsapp_threads).", evidence: "src/screens/admin/ConversacionesWhatsApp.jsx" },
    { id: "s3", laneId: "bot", type: "task", label: "Clasifica intención y recupera contexto", description: "Detecta la intención y recupera contexto (deuda, incidencias, reglamento).", evidence: "propia_agent/agents.py" },
    { id: "s4", laneId: "bot", type: "decision", label: "¿El bot resuelve o escala?" },
    { id: "s5", laneId: "bot", type: "decision", label: "¿Modo aprendizaje o producción?" },
    { id: "s6", laneId: "admin", type: "task", label: "Revisa la respuesta del bot", description: "En Revisión bot el Super Admin marca buena/mala/editar; no se envía al residente.", evidence: "src/screens/admin/RevisionBot.jsx" },
    { id: "s7", laneId: "bot", type: "notification", label: "Envía la respuesta al residente", description: "En producción la respuesta se envía por WhatsApp.", evidence: "propia_agent/agents.py" },
    { id: "s8", laneId: "bot", type: "handoff", label: "Marca el hilo como necesita humano", description: "Setea needsHuman: true; el admin lo atiende en Conversaciones.", evidence: "src/screens/admin/ConversacionesWhatsApp.jsx" },
    { id: "s9", laneId: "admin", type: "task", label: "Toma el control y responde", description: "Atiende manualmente el hilo escalado.", evidence: "src/screens/admin/MonitorAgentesIA.jsx" },
    { id: "s10", laneId: "admin", type: "handoff", label: "Devuelve el hilo al bot", description: "Tras resolver, retorna el control al bot." },
    { id: "s11", laneId: "res", type: "end", label: "Residente atendido" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "resuelve" },
    { from: "s4", to: "s8", label: "escala" },
    { from: "s5", to: "s6", label: "aprendizaje" },
    { from: "s5", to: "s7", label: "producción" },
    { from: "s6", to: "s11" },
    { from: "s7", to: "s11" },
    { from: "s8", to: "s9" },
    { from: "s9", to: "s10" },
    { from: "s10", to: "s11" },
  ],
};

export default whatsappHabi;
